import {
  ChangeDetectorRef,
  Component,
  Inject,
  inject,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TableConfiguration } from '../../../../shared/components/paginated-data-table/paginated-table-configuration.model';
import { GraphqlService } from '../../../../services/graphql.service';
import { GET_SENSOR_BY_WAREHOUSE_COUNT_DATA } from '../../../../store/entities/warehouse-management/alert-dashboard/alert-dashboard.graphql';

interface SensorRow {
  warehouseUniqueId: string;
  warehouseName: string;
  numberOfSensors: number;
  activeSensors: number;
  inactiveSensors: number;
}

interface ApiResponse {
  id: string;
  status: boolean;
  code: number;
  message: string;
}

interface SensorPayload {
  sensorsInstalled: number;
  sensorByWarehouse: SensorRow[];
}

interface GraphQLResponse {
  response: ApiResponse;
  data: SensorPayload[];
}

@Component({
  selector: 'app-total-installed-sensor-modal',
  templateUrl: './total-installed-sensor-modal.component.html',
  styleUrl: './total-installed-sensor-modal.component.scss',
  standalone: false,
})
export class TotalInstalledSensorModalComponent implements OnInit {
 
  private dialogRef = inject(MatDialogRef<TotalInstalledSensorModalComponent>);
  private apollo = inject(GraphqlService);
  private cdr = inject(ChangeDetectorRef);

  constructor(@Inject(MAT_DIALOG_DATA) private data) { }

fetchAlertData() {
  this.tableData = this.data?.stability; 
}

  title = 'Total Installed Sensors';
  loading = true;
  tableData: SensorRow[] = [];


  tableConfiguration: TableConfiguration = {
    tableColumns: [
      { name: 'warehouseName', label: 'Warehouse' },
      { name: 'numberOfSensors', label: 'Total Sensors' },
      { name: 'activeSensors', label: 'Active' },
      { name: 'inactiveSensors', label: 'Inactive' },
    ],
    tableCaption: '',
    showNumbers: true,
    tableNotifications: 'Notification',
    showSearch: true,
    useFullObject: true,
    showBorder: true,
    allowPagination: true,
    useRowClick: true,
    actionIcons: {
      edit: false,
      delete: false,
      more: false,
      print: false,
      customPrimary: false,
    },
    doneLoading: false,
    deleting: {},
    active: {},
    hideExport: true,
    customPrimaryMessage: 'Activate',
    empty_msg: 'No data found',
  };
ngOnInit(): void {
  this.fetchSensorData();
}

private async fetchSensorData(): Promise<void> {
  this.loading = true;
  this.tableConfiguration.doneLoading = false;

  try {
    const result: any = await this.apollo.query({
      query: GET_SENSOR_BY_WAREHOUSE_COUNT_DATA,
      variables: { filtering: {} },
    });

    const response = result?.data?.getSensorByWarehouseCount;
    if (response?.response?.status) {
      this.tableData = response.data[0]?.sensorByWarehouse ?? [];
      console.log('Fetched sensor data:', this.tableData); 
    } else {
      this.tableData = [];
    }
  } catch (error) {
    console.error('GraphQL error:', error);
    this.tableData = [];
  } finally {
    this.loading = false;
    this.tableConfiguration.doneLoading = true;
    this.cdr.detectChanges();
  }
}

  closeModal(): void {
    this.dialogRef.close();
  }


  mapFunction(item: SensorRow): any {
    return {
      ...item,
    
    };
  }
}